var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var DefaultErrorComponent = function () { return React.createElement("span", null, " some thing goes wrong :( "); };
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.prototype.unstable_handleError = function (error, info) {
        this.setState({ hasError: true });
        console.error(error, info);
    };
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        this.setState({ hasError: true });
        console.error(error);
    };
    ErrorBoundary.prototype.render = function () {
        return this.state.hasError
            ? this.props.ErrorComponent || DefaultErrorComponent
            : this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
var wrapErrorBoundary = function (InputComponent, ErrorComponent) {
    if (ErrorComponent === void 0) { ErrorComponent = DefaultErrorComponent; }
    return function render(props) {
        return (React.createElement(ErrorBoundary, { ErrorComponent: ErrorComponent },
            React.createElement(InputComponent, __assign({}, props))));
    };
};
export { wrapErrorBoundary };
export default ErrorBoundary;

//# sourceMappingURL=index.js.map
